import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import image from "../../assets/images/logo/noteg_website_logo_2.svg";

const SocialContent = [
  {
    icon: "fab fa-facebook-f",
    routerPath:
      "https://www.facebook.com/NoteG-Technologies-105471128505696/?ref=pages_you_manage",
  },
  {
    icon: "bi bi-youtube",
    routerPath: "https://www.youtube.com/channel/UC3ujPM164U6TbLcjqPtbULQ",
  },
  {
    icon: "fab fa-linkedin-in",
    routerPath: "https://www.linkedin.com/company/noteg-technologies/",
  },
  {
    icon: "bi bi-instagram",
    routerPath: "https://www.instagram.com/note_g_technologies/",
  },
];
const PageContent = [
  {
    name: "Home",
    routerPath: "/",
  },
  // {
  //   name: "Pricing",
  //   routerPath: "/price",
  // },
  {
    name: "About us",
    routerPath: "/about-Company",
  },
  {
    name: "Industries",
    routerPath: "/our-industries",
  },
  // {
  //   name: "Blog",
  //   routerPath: "/blog-grid",
  // },
];
const ServiceContent = [
  {
    name: "Ed Tech",
    routerPath: "/ed-tech",
  },
  {
    name: "Data Analytics",
    routerPath: "/data-analytics",
  },
  {
    name: "Technology Consulting",
    routerPath: "/Technology-Consulting",
  },
  {
    name: "Change Management",
    routerPath: "/change-management",
  },
  {
    name: "Business Strategy",
    routerPath: "/business-strategy",
  },
];
const LegalContent = [
  // {
  //   name: "Terms of use",
  //   routerPath: "/about-one",
  // },
  {
    name: "Terms & Conditions",
    routerPath: "/",
    SectionID:'terms_condition'
  },
  {
    name: "Privacy Policy",
    routerPath: "/",
    SectionID:'Privacy_Policy'
  },
  {
    name: "Cookie Policy",
    routerPath: "/",
    SectionID:'Cookie_Policy'
  },
];

const FooterFour = () => {
  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-4 footer-intro mb-40">
          <div className="logo">
            <Link to="/">
              <img src={image} alt="" width={130} />
            </Link>
          </div>
          <p>
            You will learn about the most effective technology, and gain
            practice implementing them.
          </p>
          <ul className="d-flex social-icon style-none">
            {SocialContent.map((val, i) => (
              <li key={i}>
                <a onClick={() => window.open(val.routerPath)}>
                  <i className={val.icon} />
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-lg-2 col-sm-4 ms-auto mb-30">
          <h5 className="footer-title">Links</h5>
          <ul className="footer-nav-link style-none">
            {PageContent.map((val, i) => (
              <li key={i}>
                <Link to={val.routerPath}>{val.name}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-lg-3 col-sm-4 mb-30">
          <h5 className="footer-title">Services</h5>
          <ul className="footer-nav-link style-none">
            {ServiceContent.map((val, i) => (
              <li key={i}>
                <Link to={val.routerPath}>{val.name}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-xl-2 col-lg-3 col-sm-4 mb-30">
          <h5 className="footer-title">Legal</h5>
          <ul className="footer-nav-link style-none">
            {LegalContent.map((val, i) => (
              <li key={i}>
                <Link to={val.routerPath + val.SectionID}>{val.name}</Link>               
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

export default FooterFour;
